export default __webpack_public_path__ + "static/media/reduxfront.e6f39c9f.svg";